<template>
    <p :class="['cart-button', mode]">
        <reo-common-button
            class="checkout-button"
            :ga-label="`Cart cancel(${mode})`"
            :to="`/user/dashboard/?tab=${isSim?'sim':'cloud'}`"
            :label="cancelButton"
            colorType="light"
            v-if="showCancelButton"
        />
        <reo-common-button
            :class="['checkout-button',  (mode === 'create' || (mode === 'switch' && !showSwitchInfo)) ? 'red-button' : 'primary-button']"
            :disabled="disabled"
            :ga-label="`Cart confirm(${mode})`"
            @click="$emit('click')"
            :label="checkoutButton"
        />
    </p>
</template>

<script lang="ts">

import { ESubscribeMode } from '@reolink-cloud/interface';
import Vue, { PropType } from 'vue';
import { config } from 'CONFIG';
import { getCheckoutButtonText } from '../lib/utils';

export default Vue.extend({
    props: {
        mode: {
            type: String as PropType<ESubscribeMode>
        },
        showSwitchInfo: {
            type: Boolean
        },
        needPay: {
            type: Boolean
        },
        disabled: Boolean,
        showCancelButton: Boolean,
        isSim: Boolean
    },
    data() {

        return {
            config
        };

    },
    computed: {

        checkoutButton(): string {

            return getCheckoutButtonText( this.mode, this.needPay, this.showSwitchInfo );

        },
        cancelButton(): string {

            let { mode } = this;
            return mode ? this.$tc( `cart.cancel.${mode}` ) : '';

        },
    }
});

</script>

<style lang="less" scoped>
.cart-button {
    text-align: center;

    .checkout-button+.checkout-button {
        margin-left: 0.4rem;
    }

    .checkout-button.red-button /deep/ .reo-button-inner{
        background: -webkit-linear-gradient(150deg, #eb3349, #f45c43);
        background: -moz-linear-gradient(150deg, #eb3349, #f45c43);
        background: -ms-linear-gradient(150deg, #eb3349, #f45c43);
        background: linear-gradient(150deg, #eb3349, #f45c43);
        color: #fff;
        border: 1px solid #f45c43;
        transition: none;
        cursor: pointer;
        &:disabled{
            background: none;
            background-color: @red_disable;
            border: 1px solid @red_disable;
        }
    }

    .checkout-button.red-button:hover /deep/ .reo-button-inner{
        background: none;
        background-color: @red_5;
        &:disabled{
            background-color: @red_disable;
        }
    }

    @media @snapeak_mobile {
        .checkout-button {
            width: 100%;
            box-sizing: border-box;
        }

        .checkout-button+.checkout-button {
            margin: 0.2rem 0 0;
        }

        &.create .checkout-button {
            display: none;
        }

        &.create {
            display: none;
        }
    }
}
</style>
